/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { workforce_AbsenceSummaryResponse } from '../models/workforce_AbsenceSummaryResponse';
import type { workforce_AdjustOvertimeRequest } from '../models/workforce_AdjustOvertimeRequest';
import type { workforce_OvertimeAccountResponse } from '../models/workforce_OvertimeAccountResponse';
import type { workforce_OvertimeHistoryResponse } from '../models/workforce_OvertimeHistoryResponse';
import type { workforce_RecomputeOvertimeRequest } from '../models/workforce_RecomputeOvertimeRequest';
import type { workforce_UpdateVacationEntitlementScheduleRequest } from '../models/workforce_UpdateVacationEntitlementScheduleRequest';
import type { workforce_UpsertVacationEntitlementScheduleRequest } from '../models/workforce_UpsertVacationEntitlementScheduleRequest';
import type { workforce_VacationEntitlementScheduleListResponse } from '../models/workforce_VacationEntitlementScheduleListResponse';
import type { workforce_VacationEntitlementScheduleResponse } from '../models/workforce_VacationEntitlementScheduleResponse';
import type { workforce_VacationSummaryResponse } from '../models/workforce_VacationSummaryResponse';
import type { workforce_WorkforceSummaryResponse } from '../models/workforce_WorkforceSummaryResponse';
import type { workforce_ZeitkontoProjectionResponse } from '../models/workforce_ZeitkontoProjectionResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WorkforceService {
    /**
     * Get an employee's sick and accident days of a year
     * The approved SICK and ACCIDENT days of the year: the Monday-to-Friday days of each absence inside the year, 0.5 for a part-day absence (#1979). The same number the employee sees in the employee app and the cockpit's absence metric counts.
     * @param employeeId Employee ID
     * @param year Calendar year (default: current year)
     * @returns workforce_AbsenceSummaryResponse OK
     * @throws ApiError
     */
    public static getApiV1WorkforceAbsenceSummary(
        employeeId: string,
        year?: number,
    ): CancelablePromise<workforce_AbsenceSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workforce/absence-summary',
            query: {
                'employee_id': employeeId,
                'year': year,
            },
            errors: {
                400: `Missing or invalid parameters`,
                403: `Organization ID not found in token`,
                500: `Failed to get absence summary`,
            },
        });
    }
    /**
     * Get overtime history for an employee
     * Get monthly overtime account records for a date range
     * @param employeeId Employee ID
     * @param fromMonth Start month (YYYY-MM)
     * @param toMonth End month (YYYY-MM)
     * @returns workforce_OvertimeHistoryResponse OK
     * @throws ApiError
     */
    public static getApiV1WorkforceOvertime(
        employeeId: string,
        fromMonth: string,
        toMonth: string,
    ): CancelablePromise<workforce_OvertimeHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workforce/overtime/{employeeId}',
            path: {
                'employeeId': employeeId,
            },
            query: {
                'from_month': fromMonth,
                'to_month': toMonth,
            },
            errors: {
                400: `Missing or invalid parameters`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Overtime account not found`,
                500: `Failed to get overtime history`,
            },
        });
    }
    /**
     * Manually adjust an overtime account
     * Add a manual adjustment to an overtime account with a reason
     * @param request Overtime adjustment data
     * @returns workforce_OvertimeAccountResponse OK
     * @throws ApiError
     */
    public static postApiV1WorkforceOvertimeAdjust(
        request: workforce_AdjustOvertimeRequest,
    ): CancelablePromise<workforce_OvertimeAccountResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workforce/overtime/adjust',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Overtime account not found`,
                500: `Failed to adjust overtime`,
            },
        });
    }
    /**
     * Recompute an employee's monthly Zeitkonto
     * Materialize the overtime account for an employee-month from contract, shifts, time entries, absences, and holidays
     * @param request Recompute parameters
     * @returns workforce_OvertimeAccountResponse OK
     * @throws ApiError
     */
    public static postApiV1WorkforceOvertimeRecompute(
        request: workforce_RecomputeOvertimeRequest,
    ): CancelablePromise<workforce_OvertimeAccountResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workforce/overtime/recompute',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to recompute overtime`,
            },
        });
    }
    /**
     * Get workforce summary
     * Get plan-vs-actual-vs-target hour comparison for employees
     * @param fromDate Start date (YYYY-MM-DD)
     * @param toDate End date (YYYY-MM-DD)
     * @param employeeId Filter by employee ID
     * @param granularity Aggregation granularity: daily, weekly, monthly (default: daily)
     * @returns workforce_WorkforceSummaryResponse OK
     * @throws ApiError
     */
    public static getApiV1WorkforceSummary(
        fromDate: string,
        toDate: string,
        employeeId?: string,
        granularity?: string,
    ): CancelablePromise<workforce_WorkforceSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workforce/summary',
            query: {
                'from_date': fromDate,
                'to_date': toDate,
                'employee_id': employeeId,
                'granularity': granularity,
            },
            errors: {
                400: `Missing or invalid parameters`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to get workforce summary`,
            },
        });
    }
    /**
     * List vacation entitlement schedule
     * List the company-wide per-year vacation entitlement schedule
     * @returns workforce_VacationEntitlementScheduleListResponse OK
     * @throws ApiError
     */
    public static getApiV1WorkforceVacationEntitlementSchedule(): CancelablePromise<workforce_VacationEntitlementScheduleListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workforce/vacation-entitlement-schedule',
            errors: {
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to list vacation entitlement schedule`,
            },
        });
    }
    /**
     * Create or update a vacation entitlement schedule entry
     * Create or update the company-wide vacation entitlement for a calendar year (upsert on year)
     * @param request Schedule entry data
     * @returns workforce_VacationEntitlementScheduleResponse Created
     * @throws ApiError
     */
    public static postApiV1WorkforceVacationEntitlementSchedule(
        request: workforce_UpsertVacationEntitlementScheduleRequest,
    ): CancelablePromise<workforce_VacationEntitlementScheduleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workforce/vacation-entitlement-schedule',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to create vacation entitlement schedule entry`,
            },
        });
    }
    /**
     * Delete a vacation entitlement schedule entry
     * Soft-delete a schedule entry by ID
     * @param id Schedule entry ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1WorkforceVacationEntitlementSchedule(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/workforce/vacation-entitlement-schedule/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing schedule entry ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Schedule entry not found`,
                500: `Failed to delete vacation entitlement schedule entry`,
            },
        });
    }
    /**
     * Update a vacation entitlement schedule entry
     * Update the entitlement days of an existing schedule entry by ID
     * @param id Schedule entry ID
     * @param request Updated entitlement data
     * @returns workforce_VacationEntitlementScheduleResponse OK
     * @throws ApiError
     */
    public static patchApiV1WorkforceVacationEntitlementSchedule(
        id: string,
        request: workforce_UpdateVacationEntitlementScheduleRequest,
    ): CancelablePromise<workforce_VacationEntitlementScheduleResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/workforce/vacation-entitlement-schedule/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Schedule entry not found`,
                500: `Failed to update vacation entitlement schedule entry`,
            },
        });
    }
    /**
     * Get derived vacation summary
     * Get entitlement/used/remaining vacation for an employee and year, in days and hours
     * @param employeeId Employee ID
     * @param year Calendar year (default: current year)
     * @returns workforce_VacationSummaryResponse OK
     * @throws ApiError
     */
    public static getApiV1WorkforceVacationSummary(
        employeeId: string,
        year?: number,
    ): CancelablePromise<workforce_VacationSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workforce/vacation-summary',
            query: {
                'employee_id': employeeId,
                'year': year,
            },
            errors: {
                400: `Missing or invalid parameters`,
                403: `Organization ID not found in token`,
                500: `Failed to get vacation summary`,
            },
        });
    }
    /**
     * Get planner Zeitkonto projection
     * Get current + projected overtime balance per employee for a planner window
     * @param from Start date (YYYY-MM-DD)
     * @param to End date (YYYY-MM-DD)
     * @param employeeIds Comma-separated employee IDs
     * @returns workforce_ZeitkontoProjectionResponse OK
     * @throws ApiError
     */
    public static getApiV1WorkforceZeitkontoProjection(
        from: string,
        to: string,
        employeeIds: string,
    ): CancelablePromise<workforce_ZeitkontoProjectionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workforce/zeitkonto-projection',
            query: {
                'from': from,
                'to': to,
                'employee_ids': employeeIds,
            },
            errors: {
                400: `Missing or invalid parameters`,
                403: `Organization ID not found in token`,
                500: `Failed to get Zeitkonto projection`,
            },
        });
    }
}
